<template>
  <div class="us">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">关于我们</h1>
        <p class="page-subtitle">传承电影文化 · 引领行业创新</p>
        <div class="page-decoration"></div>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容 -->
      <div class="us-content">
        <!-- 左侧图片 -->
        <div class="us-img">
          <div class="img-container">
            <img src="/imgs/us.jpg" alt="首都电影院" />
            <div class="img-overlay">
              <div class="overlay-content">
                <div class="custom-icon cinema-icon"></div>
                <span>始于1937</span>
              </div>
            </div>
          </div>
          <!-- 图片装饰 -->
          <div class="img-decoration">
            <div class="decoration-item"></div>
            <div class="decoration-item"></div>
            <div class="decoration-item"></div>
          </div>
        </div>
        
        <!-- 右侧介绍 -->
        <div class="us-info">
          <!-- 标题区域 -->
          <div class="info-header">
            <h2>首都电影院</h2>
            <div class="title-decoration"></div>
            <p class="info-subtitle">CAPITAL CINEMA - 中国电影放映界的旗帜</p>
          </div>

          <!-- 内容区域 -->
          <div class="info-content">
            <!-- 历史沿革 -->
            <div class="content-section">
              <div class="section-header">
                <div class="custom-icon history-icon"></div>
                <h3>历史沿革</h3>
              </div>
              <p>
                首都电影院的前身是1937年著名京剧艺术家马连良先生及友人筹资兴建的新新大戏院。1950年周恩来总理亲自命名、时任政务院副总理郭沫若先生题写院名的首都电影院正式开业，成为中国第一座国家级电影院。
              </p>
            </div>

            <!-- 发展成就 -->
            <div class="content-section">
              <div class="section-header">
                <div class="custom-icon achievement-icon"></div>
                <h3>发展成就</h3>
              </div>
              <p>
                伴随着中国电影行业的飞速发展，首都电影院先后成为北京第一家光学立体声影院、北京首个票房收入超百万元、破千万的影院，也曾被誉为"中国电影放映界的一面旗帜"。
              </p>
            </div>

            <!-- 企业背景 -->
            <div class="content-section">
              <div class="section-header">
                <div class="custom-icon enterprise-icon"></div>
                <h3>企业背景</h3>
              </div>
              <p>
                首都电影院是西城区国资委直接监管企业"北京天桥盛世投资集团有限责任公司"旗下的子公司。天桥盛世集团是西城区文化事业建设和文化产业发展的综合性业务平台，服务于北京建设全国文化中心、非首都功能疏解和区域经济发展转型。
              </p>
            </div>

            <!-- 规模数据 -->
            <div class="stats-grid">
              <div class="stat-card">
                <div class="stat-icon">
                  <div class="custom-icon branch-icon"></div>
                </div>
                <div class="stat-content">
                  <div class="stat-number">8</div>
                  <div class="stat-label">门店数量</div>
                </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">
                  <div class="custom-icon screen-icon"></div>
                </div>
                <div class="stat-content">
                  <div class="stat-number">62</div>
                  <div class="stat-label">银幕数量</div>
                </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">
                  <div class="custom-icon seat-icon"></div>
                </div>
                <div class="stat-content">
                  <div class="stat-number">8,823</div>
                  <div class="stat-label">座位总数</div>
                </div>
              </div>
              <div class="stat-card">
                <div class="stat-icon">
                  <div class="custom-icon partner-icon"></div>
                </div>
                <div class="stat-content">
                  <div class="stat-number">4</div>
                  <div class="stat-label">行业组织</div>
                </div>
              </div>
            </div>

            <!-- 合作院线 -->
            <div class="partners-section">
              <h4>合作院线与组织</h4>
              <div class="partners-list">
                <span class="partner-tag">新影联院线</span>
                <span class="partner-tag">人民院线</span>
                <span class="partner-tag">全国艺联</span>
                <span class="partner-tag">首艺联</span>
              </div>
            </div>

          
          </div>
        </div>
      </div>

      <!-- 特色服务区块 -->
      <div class="features-section">
        <div class="section-header">
          <h2>我们的特色服务</h2>
          <p>为您提供卓越的电影观影体验</p>
          <div class="title-decoration"></div>
        </div>
        
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <div class="custom-icon premium-icon"></div>
            </div>
            <h3>VIP观影服务</h3>
            <p>专属VIP影厅，豪华座椅，私密空间，为您提供尊贵的观影体验</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <div class="custom-icon tech-icon"></div>
            </div>
            <h3>先进放映技术</h3>
            <p>IMAX、杜比全景声、4K激光放映，带来震撼的视听盛宴</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <div class="custom-icon event-icon"></div>
            </div>
            <h3>电影文化活动</h3>
            <p>首映礼、导演见面会、影迷沙龙，丰富的电影文化交流活动</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <div class="custom-icon service-icon"></div>
            </div>
            <h3>贴心客户服务</h3>
            <p>专业客服团队，完善的会员体系，为您提供全方位的服务支持</p>
          </div>
        </div>
      </div>

      <!-- 时间线区块 -->
      <div class="timeline-section">
        <div class="section-header">
          <h2>发展历程</h2>
          <p>见证中国电影发展的光辉岁月</p>
          <div class="title-decoration"></div>
        </div>
        
        <div class="timeline">
          <div class="timeline-item">
            <div class="timeline-year">1937</div>
            <div class="timeline-content">
              <h4>新新大戏院成立</h4>
              <p>由著名京剧艺术家马连良先生及友人筹资兴建</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">1950</div>
            <div class="timeline-content">
              <h4>首都电影院正式命名</h4>
              <p>周恩来总理亲自命名，郭沫若先生题写院名</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">1980</div>
            <div class="timeline-content">
              <h4>技术创新引领</h4>
              <p>成为北京第一家光学立体声影院</p>
            </div>
          </div>
          <div class="timeline-item">
            <div class="timeline-year">2000</div>
            <div class="timeline-content">
              <h4>业务扩展</h4>
              <p>管理8家门店，拥有62块银幕，8823个座位</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 联系我们
    goContact() {
      alert('请联系我们：400-xxx-xxxx');
    },
    // 了解更多历史
    goHistory() {
      this.$router.push('/history');
    }
  },
  mounted() {
    document.title = "首都电影院";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.us {
  width: 100%;
  margin-top: 100px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f8f9fa 100%);
  min-height: 100vh;

  // 页面头部
  .page-header {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    color: white;
    padding: 60px 0 40px;
    margin-bottom: 60px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="film" width="10" height="10" patternUnits="userSpaceOnUse"><rect width="10" height="10" fill="none"/><circle cx="2" cy="2" r="1" fill="%23ffd700" opacity="0.3"/><circle cx="8" cy="8" r="1" fill="%23ffd700" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23film)"/></svg>');
      opacity: 0.1;
    }

    .container {
      position: relative;
      z-index: 1;
      text-align: center;
    }

    .page-title {
      font-size: 42px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #ffd700;
      text-shadow: 0 2px 10px rgba(255, 215, 0, 0.3);
    }

    .page-subtitle {
      font-size: 18px;
      opacity: 0.9;
      margin-bottom: 20px;
      letter-spacing: 1px;
    }

    .page-decoration {
      height: 4px;
      background: linear-gradient(90deg, transparent, #ffd700, transparent);
      border-radius: 2px;
      margin: 0 auto;
      width: 100px;
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  // 自定义图标样式
  .custom-icon {
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    
    &.cinema-icon {
      width: 48px;
      height: 48px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z'/%3E%3C/svg%3E");
    }
    
    &.history-icon {
      width: 20px;
      height: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z'/%3E%3C/svg%3E");
    }
    
    &.achievement-icon {
      width: 20px;
      height: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z'/%3E%3C/svg%3E");
    }
    
    &.enterprise-icon {
      width: 20px;
      height: 20px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z'/%3E%3C/svg%3E");
    }
    
    &.branch-icon, &.screen-icon, &.seat-icon, &.partner-icon,
    &.premium-icon, &.tech-icon, &.event-icon, &.service-icon,
    &.contact-icon, &.more-icon {
      width: 24px;
      height: 24px;
    }
    
    &.branch-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'/%3E%3C/svg%3E");
    }
    
    &.screen-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z'/%3E%3C/svg%3E");
    }
    
    &.seat-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M4 18v3h3v-3h10v3h3v-6H4v3zm15-8h3v3h-3v-3zM2 10h3v3H2v-3zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z'/%3E%3C/svg%3E");
    }
    
    &.partner-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'/%3E%3C/svg%3E");
    }
    
    &.premium-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z'/%3E%3C/svg%3E");
    }
    
    &.tech-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z'/%3E%3C/svg%3E");
    }
    
    &.event-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z'/%3E%3C/svg%3E");
    }
    
    &.service-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z'/%3E%3C/svg%3E");
    }
    
    &.contact-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'%3E%3Cpath d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z'/%3E%3C/svg%3E");
    }
    
    &.more-icon {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ffd700'%3E%3Cpath d='M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'/%3E%3C/svg%3E");
    }
  }

  // 主要内容
  .us-content {
    display: flex;
    gap: 50px;
    margin-bottom: 80px;
    align-items: flex-start;

    // 左侧图片
    .us-img {
      flex: 0 0 45%;
      position: relative;

      .img-container {
        position: relative;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        border: 1px solid rgba(255, 215, 0, 0.2);

        img {
          width: 100%;
          height: 500px;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .img-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(255, 215, 0, 0.1) 0%, rgba(0, 0, 0, 0.3) 100%);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.3s ease;

          .overlay-content {
            text-align: center;
            color: white;

            .cinema-icon {
              margin-bottom: 10px;
            }

            span {
              font-size: 18px;
              font-weight: bold;
              text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
            }
          }
        }

        &:hover {
          img {
            transform: scale(1.05);
          }

          .img-overlay {
            opacity: 1;
          }
        }
      }

      .img-decoration {
        display: flex;
        justify-content: center;
        gap: 10px;
        margin-top: 20px;

        .decoration-item {
          width: 60px;
          height: 4px;
          background: linear-gradient(90deg, #ffd700, transparent);
          border-radius: 2px;

          &:nth-child(2) {
            background: linear-gradient(90deg, transparent, #ffd700, transparent);
          }

          &:nth-child(3) {
            background: linear-gradient(90deg, transparent, #ffd700);
          }
        }
      }
    }

    // 右侧介绍
    .us-info {
      flex: 1;

      .info-header {
        margin-bottom: 40px;

        h2 {
          font-size: 36px;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 10px;
          background: linear-gradient(135deg, #ffd700, #ffed4e);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .title-decoration {
          height: 3px;
          background: linear-gradient(90deg, #ffd700, transparent);
          border-radius: 2px;
          margin-bottom: 15px;
        }

        .info-subtitle {
          font-size: 16px;
          color: #666;
          font-style: italic;
          letter-spacing: 1px;
        }
      }

      .info-content {
        .content-section {
          margin-bottom: 30px;

          .section-header {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 15px;

            .custom-icon {
              flex-shrink: 0;
            }

            h3 {
              font-size: 20px;
              font-weight: bold;
              color: #1a1a1a;
              margin: 0;
            }
          }

          p {
            font-size: 15px;
            line-height: 1.8;
            color: #555;
            margin: 0;
            text-align: justify;
          }
        }

        // 数据统计网格
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          margin: 40px 0;

          .stat-card {
            background: white;
            padding: 25px 20px;
            border-radius: 15px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(255, 215, 0, 0.1);
            display: flex;
            align-items: center;
            gap: 15px;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 15px 35px rgba(255, 215, 0, 0.15);
            }

            .stat-icon {
              width: 50px;
              height: 50px;
              background: linear-gradient(135deg, #ffd700, #ffed4e);
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;

              .custom-icon {
                width: 24px;
                height: 24px;
              }
            }

            .stat-content {
              .stat-number {
                font-size: 28px;
                font-weight: bold;
                color: #1a1a1a;
                margin-bottom: 5px;
              }

              .stat-label {
                font-size: 14px;
                color: #666;
              }
            }
          }
        }

        // 合作伙伴
        .partners-section {
          margin: 40px 0;

          h4 {
            font-size: 18px;
            font-weight: bold;
            color: #1a1a1a;
            margin-bottom: 15px;
          }

          .partners-list {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;

            .partner-tag {
              background: rgba(255, 215, 0, 0.1);
              color: #ffd700;
              padding: 8px 16px;
              border-radius: 20px;
              font-size: 14px;
              font-weight: 500;
              border: 1px solid rgba(255, 215, 0, 0.3);
              transition: all 0.3s ease;

              &:hover {
                background: #ffd700;
                color: #000;
                transform: translateY(-2px);
              }
            }
          }
        }

        // 行动按钮
        .action-buttons {
          display: flex;
          gap: 20px;
          margin-top: 40px;

          .primary-btn, .secondary-btn {
            padding: 14px 30px;
            border-radius: 25px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            gap: 8px;
            border: none;
            font-size: 15px;
          }

          .primary-btn {
            background: linear-gradient(135deg, #ffd700, #ffed4e);
            color: #000;
            box-shadow: 0 6px 20px rgba(255, 215, 0, 0.3);

            &:hover {
              transform: translateY(-3px);
              box-shadow: 0 10px 25px rgba(255, 215, 0, 0.4);
            }
          }

          .secondary-btn {
            background: transparent;
            color: #ffd700;
            border: 2px solid #ffd700;

            &:hover {
              background: rgba(255, 215, 0, 0.1);
              transform: translateY(-3px);
            }
          }
        }
      }
    }
  }

  // 特色服务区块
  .features-section {
    margin-bottom: 80px;

    .section-header {
      text-align: center;
      margin-bottom: 50px;

      h2 {
        font-size: 32px;
        font-weight: bold;
        color: #1a1a1a;
        margin-bottom: 15px;
      }

      p {
        font-size: 16px;
        color: #666;
        margin-bottom: 20px;
      }

      .title-decoration {
        height: 3px;
        background: linear-gradient(90deg, transparent, #ffd700, transparent);
        border-radius: 2px;
        margin: 0 auto;
        width: 80px;
      }
    }

    .features-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;

      .feature-card {
        background: white;
        padding: 40px 25px;
        border-radius: 20px;
        text-align: center;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
        border: 1px solid rgba(255, 215, 0, 0.1);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(255, 215, 0, 0.15);
        }

        .feature-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #ffd700, #ffed4e);
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 25px;

          .custom-icon {
            width: 36px;
            height: 36px;
          }
        }

        h3 {
          font-size: 20px;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 15px;
        }

        p {
          font-size: 14px;
          line-height: 1.6;
          color: #666;
          margin: 0;
        }
      }
    }
  }

  // 时间线区块
  .timeline-section {
    margin-bottom: 80px;

    .section-header {
      text-align: center;
      margin-bottom: 50px;

      h2 {
        font-size: 32px;
        font-weight: bold;
        color: #1a1a1a;
        margin-bottom: 15px;
      }

      p {
        font-size: 16px;
        color: #666;
        margin-bottom: 20px;
      }

      .title-decoration {
        height: 3px;
        background: linear-gradient(90deg, transparent, #ffd700, transparent);
        border-radius: 2px;
        margin: 0 auto;
        width: 80px;
      }
    }

    .timeline {
      position: relative;
      max-width: 800px;
      margin: 0 auto;

      &::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 0;
        bottom: 0;
        width: 2px;
        background: linear-gradient(180deg, #ffd700, rgba(255, 215, 0, 0.3));
        transform: translateX(-50%);
      }

      .timeline-item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        position: relative;

        &:nth-child(odd) {
          flex-direction: row-reverse;

          .timeline-content {
            text-align: right;
            margin-right: 40px;
            margin-left: 0;
          }
        }

        .timeline-year {
          flex: 0 0 100px;
          text-align: center;
          background: linear-gradient(135deg, #ffd700, #ffed4e);
          color: #000;
          padding: 12px 20px;
          border-radius: 25px;
          font-weight: bold;
          font-size: 16px;
          box-shadow: 0 4px 15px rgba(255, 215, 0, 0.3);
          position: relative;
          z-index: 2;
        }

        .timeline-content {
          flex: 1;
          background: white;
          padding: 25px;
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
          margin-left: 40px;
          border: 1px solid rgba(255, 215, 0, 0.1);

          h4 {
            font-size: 18px;
            font-weight: bold;
            color: #1a1a1a;
            margin-bottom: 10px;
          }

          p {
            font-size: 14px;
            line-height: 1.6;
            color: #666;
            margin: 0;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .us-content {
    flex-direction: column !important;
    gap: 40px !important;
  }

  .us-img {
    flex: 1 !important;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
}

@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: 1fr !important;
  }

  .features-grid {
    grid-template-columns: 1fr !important;
  }

  .action-buttons {
    flex-direction: column !important;
  }

  .timeline::before {
    left: 30px !important;
  }

  .timeline-item {
    flex-direction: row !important;

    &:nth-child(odd) {
      flex-direction: row !important;
    }

    .timeline-content {
      margin-left: 60px !important;
      margin-right: 0 !important;
      text-align: left !important;
    }
  }
}
</style>